import { Tooltip } from 'antd'
import { WithDisabled } from '../../hooks/useDisabledOptions'
import { parseDisabled } from '../../utils/parseDisabled'

/**
 * Before writing end-to-end tests:
 *
 * `/library/testing/README.md` > End-to-End testing > Ant Design Oddities > Tooltips
 */
const DisabledTooltip: React.FC<WithDisabled> = ({ disabled, children }) => (
  <Tooltip title={parseDisabled(disabled)}>{children}</Tooltip>
)

export default DisabledTooltip
